import { render, staticRenderFns } from "./DownButton.vue?vue&type=template&id=383b4193&scoped=true"
import script from "./DownButton.vue?vue&type=script&lang=js"
export * from "./DownButton.vue?vue&type=script&lang=js"
import style0 from "./DownButton.vue?vue&type=style&index=0&id=383b4193&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "383b4193",
  null
  
)

export default component.exports